import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Personal-Website/Personal-Website/src/components/layout/MD_Layout.js";
import { Box } from "theme-ui";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Charter Network Benchmarks`}</h1>
    <p>{`Sometimes my internet seems slower than what I pay for and for that I resent
Charter. Let us find out if that resentment is valid or misplaced.`}</p>
    <p>{`Null Hypothesis: Download Speeds at 5pm >= Download Speeds at the other hours
of the day`}</p>
    <p>{`Alternative Hypothesis: Download Speeds at 5pm < Download Speeds at the
other hours of the day`}</p>
    <h2>{`Collecting the Data`}</h2>
    <p>{`To collect the data that I needed to test this hypothesis I used a Python script
that collected my network data set to run every ten minutes. The script was run
from a raspberry pi hooked up to my router with an ethernet cord to remove
my choppy wifi as a variable. Script details can be found on my
`}<a parentName="p" {...{
        "href": "/blog/Benchmarking_Network_With_Python"
      }}>{`blog post`}</a>{`.`}</p>
    <p>{`In the end I generated ~13000 data points over 3 months which can be found
on `}<a parentName="p" {...{
        "href": "https://raw.githubusercontent.com/CannonLock/data/master/benchmark.csv"
      }}>{`github`}</a>{`.`}</p>
    <h2>{`Visual Analysis`}</h2>
    <p>{`It's no fun jumping right to the math, lets see if we can spot something
interesting in some graphs.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "500px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/1f536375f10c4c9fc36696ef6734f074/0b533/download_box_plot.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Download Box Plot",
            "title": "Download Box Plot",
            "src": "/static/1f536375f10c4c9fc36696ef6734f074/0b533/download_box_plot.png",
            "srcSet": ["/static/1f536375f10c4c9fc36696ef6734f074/5a46d/download_box_plot.png 300w", "/static/1f536375f10c4c9fc36696ef6734f074/0b533/download_box_plot.png 500w"],
            "sizes": "(max-width: 500px) 100vw, 500px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`From this box plot it looks like the download speeds have
increased variance from 10:00 AM and 10:00 PM but consistent medians. Let's
graph the distributions and see if we can get glean any
more information.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "640px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0b39d00b14b12040fbfea4fc1aa15e7d/6af66/hourly_distribution.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA9hAAAPYQGoP6dpAAADu0lEQVQ4y1WUX2xTVRzHj9uY61ra2qGdA2Fjg2A7dBN5MvoC1I0JhIQE44NvPvhojNHETR/YwogwBGOi6AjMxcwADw4FDP/2R2Gp62j3p/872620a3vv7W17e9vec+/9mXPbW+NJTu7vd37J9/fJ9/zORb9OTqLBwUEEAEgUJeVbyoaRhPNKTHY+NosELlrNS5kgEos0kiVRyTOha4gN/IwY72WEpqam0YULF0lBI0myFgAaZUnYLEuYxGRrhNzac2Ipo1NzWSzpJbGglSVMzp7lovebs+HJeiKsLL1ebwwGAh0A8AIAGJKOoXcLlMsKAGbSYGPu0w9ya3e6AeB5ANiUXBh6n4tNvw4AWwCgZmPusw8Tf3/ZtvH4E6Suukh4tQ0A75RkeSvjvnSklFltlyVMmrxI8gK9ROIdpCnj/uF4kVnZDQDbiGja/1Mv4xk10UsXy2omk8ng83lbAaAJAHTxRx8TAkJoAoD6hL3/ZDZ8s6tSr03YvziZjdzapxIm7APvpRZOv5SwD1QJN/0TjrYC4A4JF1sZz2iPwK3vBADSZCvrH7fxqQWrJBbbiQ1s8Bcbn5zfiwvUy4Q47Rt7J+29YqKXvy2rNWg26wMeRweArBCmFk738UmHRcI88bQhOX/qGPf0YWfFw7qU86s+7unDLgkXSF5Luc4dple+a6Zc55By7Qih2ohnqhPE7B5czOxgPD/2FKhFK87HiUgL47ncw8Vm9mI+pVwUG5iw5db+eK3IuF8lTdjgRA8bmDAyntEyoaZRb/C7CaFICLWUa+RgfmPOUvGoIfVkuDcfn7VWPKxPPTlzmIs+6FQ9pVwjvYz7ezPlGqkS1qy5b3fLxcQeGaAlE7r+Zi5ya5+QjxGR5rT3yiEu+qAL88myZ/5xWzbye7eQi5D6FjYw8XYmdMOY9o1VCLUGg3/F3gEgKB4mHYNH8vG/VEJN0jF0tEJEPKtPOk4dz63ffUWdyzLhJTPlOv8fYdh1bb/MRy2yDNvSvrEDbOjGfsynLIqH3qu2TPi3boGLdSrE/vFDufV7XQVmhQy7Oe0f72ND142M92qZUKvTGyKrPjK4TbjEGenFs30yv7678nJ0tPPMMcwuWSpEGnpx5KhA2VUP62jn8Alm+ZsW2jlcJXxm9uZZK0d5txdzcXNo+vO3lv8c3cUm3G0S5ppCMwNvOO+f38UmysO/OtN/cP7u1+0ZKrydPNXgdP8B971+3dLtj6qDXfmTSGoDrXImJv6fA4fyRYmEjcQmAIxmHjnVeg0R+hcNsvI6EHqI4wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Hourly Distributions",
            "title": "Hourly Distributions",
            "src": "/static/0b39d00b14b12040fbfea4fc1aa15e7d/6af66/hourly_distribution.png",
            "srcSet": ["/static/0b39d00b14b12040fbfea4fc1aa15e7d/5a46d/hourly_distribution.png 300w", "/static/0b39d00b14b12040fbfea4fc1aa15e7d/0a47e/hourly_distribution.png 600w", "/static/0b39d00b14b12040fbfea4fc1aa15e7d/6af66/hourly_distribution.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "640px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/eac95c61367acb719513278e575390b0/6af66/hourly_distribution_1300.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA9hAAAPYQGoP6dpAAADlklEQVQ4y4WUbUxbVRjH/y19f2EtYFmirY3CBhadMROJ2Og2iNFNTGCOLb6wsYShYtRI0qxoomlM1H1A90HnxEVtSDYwuJTBxOHCS5b5RWcYkRqwXTtY2Rwlqx20t/eex5zby0LiB0/y5Dz33HN+9/+c8z8XRATeYrEYeM4jm81CGVcDKACgUfq1HLPhqTvzeYjZWxDSC1hbWJBIJCxEVCRJ0gYisqVSqaJAIFDm9/s3d3V1Vfn9/kqfz1fR2dn58HfB4D1EZCWiQiIy8l7KrRTkVv+WxcHhcJji8fhGIioVRdHIGOPQu5TJBv4hBaDP5wJ/r7o20b5t/ueX/URUIqQXDLI4r9cLt9ttDofDDiKyZzIZDRGZGGO2ZDKpW1pa0q2srNjT6bRpcXFRy/N/rv9mGdkLXBmse2b2lIeujr740sDjwFgbVGhoaIDL5TLE43GuyC4Iwh0gY0yrBM9NkiRpeL66NG0Z2gnEhnfumOt7kK7+tOfg0C5g4g2oUFNTw4HmSCTCFRYJgqAlIjOHE5FOCbsyppWrWJ6x9pbJwHoZeG5va6geGH8VKtTW1sLpdBr/D8gYWwcMW4P3cuCu/wIbGxtRXl7OgcV84xOD30CGMGZhjKl4EJFFAYMxZklfmzBMH1MhGtq+nQPjI00tP+4GLrwDFTweDxylpborUVlhsUCkIUk0K6r0PNaVrGOM2TPLf1q/NKwreXTfwVAdMNYOFR6rfhRul1MXX0iUcD+J49/rZbswyUaMaeUyGbMpFuIHZlu9OWUZ2QPEzjbkD+Vcc+uZZ4GJDqjgLNuMbVsqjcNcQd+RDnb0tcPc6jTzy0YWvWykXFbPxJxdyt02S7lVrZS7zT1pSMWGC6Ohpy7OnariCg+cflLZQ5hcqNxUbrzAjdvd9gf7pOUINRVjjkhN9fJNUot5U3N1aiLiptYsh782z/VvSeZ9uG//D941IErgqazQxviiz9qjrLutl872PEFfvBWkE/79bDJUTOFRd3L60/tvTh+3Czcm76bUJfv8ePvWyEB15q/+h7ix207vUHyoNPWJYG/Rjc99zXTs7RbxK9+B5Eet74s9hw/RUI83djLwXGT0lReWf/VXzE5+XB0e+7Amcb65cWbg6UOX++o6kpc+eOA4gP6tCq3QapF7oknc6n4dFHwPNBYAffsukieP5v8o4Q78PvgmiObl56mB3aCFJtD15/lSY9V9+oJHKjbgX48DnTJertWwAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Hourly Distributions for hours 13:00",
            "title": "Hourly Distributions for hours 13:00",
            "src": "/static/eac95c61367acb719513278e575390b0/6af66/hourly_distribution_1300.png",
            "srcSet": ["/static/eac95c61367acb719513278e575390b0/5a46d/hourly_distribution_1300.png 300w", "/static/eac95c61367acb719513278e575390b0/0a47e/hourly_distribution_1300.png 600w", "/static/eac95c61367acb719513278e575390b0/6af66/hourly_distribution_1300.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`From these arrays of graphs and the one that I have blown up it looks like
our data is `}<strong parentName="p">{`not normally distributed`}</strong>{` as I had hoped. Additionally
it isn't `}<a parentName="p" {...{
        "href": "https://www.statology.org/unimodal-distribution/"
      }}>{`unimodal`}</a>{`,
which means I do not have any tools to transform it to a
normal distribution. This is unfortunate because my plan to use an ANOVA
and a pairwise comparison to investigate my claim is now out the door.`}</p>
    <p><strong parentName="p">{`Next step -> Logistic Regression ( Coming Spring of 2022 )`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      